<template>
    <div>
        <section class="hero is-primary is-light">
				<div class="hero-body">
					<div class="container">
						<h1 class="title">Pathology Job Services</h1>
						<h2 class="subtitle">List Of Job Services</h2>
                <b-button type="is-info is-light" icon-left="plus" @click="newCheckIn" >New Checkin or New Job Services</b-button>
					</div>
				</div>
		</section>





        <section class="mr-5 ml-5 mt-5 mb-5">
            <nav class="level is-mobile">
						<div class="level-left">
							<div class="level-item has-text-weight-semibold has-text-primary">
                                เดือนบันทึก  
							</div>

                            <div class="level-item has-text-primary">
                                <b-datepicker
                                            v-model="datePathoJobStopModel"
                                                type="month"
                                                placeholder="Click to select..."
                                                icon="calendar-today"
                                                trap-focus>
                                </b-datepicker>
                            </div>


                            <div class="level-item">
                                <b-button type="is-success is-light" class="mr-3" icon-left="refresh" @click="loadJobListOfPathoServices">Refresh</b-button>
                            </div>
						</div>


                        <div class="level-left">
                            <div class="level-item" v-if="opdPathoJobList.length>0">
                                <b-button 
                                 icon-left="file-delimited"
                                 @click="saveToCSV">CSV</b-button>  
                            </div>    
                        </div>    
			</nav>

       </section>





       <section  class="mr-5 ml-5 mt-3">
		<b-table
                                :data="isEmpty ? [] : opdPathoJobList "
                                bordered
                                striped
                                narrowed
                                hoverable
                                :loading="isTableLoading"
                                focusable
                                mobile-cards

                                paginated
                                :per-page="perPage"
                                :current-page.sync="currentPage"
                             
                        >
						<b-table-column  label="Visit No./Job ID" centered v-slot="props">
                                    <!-- {{ props.row.visit_no }} -->
                                <b-dropdown aria-role="list"     >
                                <template #trigger>
                                      <b-button
                                            :type="props.row.status == -1 ? 'is-danger is-light'   : 'is-primary is-light'"
                                            icon-right='menu-down' >
                                            {{ props.row.visit_no }}
                                      </b-button>      
                                </template>


                                <b-dropdown-item   aria-role="listitem" @click="printStickerLab(props.row)">Print LN/LOR</b-dropdown-item>
                                <b-dropdown-item   aria-role="listitem" @click="printStickerHN(props.row)" >Print HN</b-dropdown-item>
                                <b-dropdown-item   aria-role="listitem" @click="disableJobID(props.row)" v-if="props.row.status == 0" :disabled="props.row.status == -1" >ยกเลิก(disable)</b-dropdown-item>
                                <b-dropdown-item    aria-role="listitem" v-clipboard:copy="props.row.visit_no" @click="clickCopyIntoClipboard(props.row.visit_no )">Copy to clipboard</b-dropdown-item>

                            </b-dropdown>

                         


                        </b-table-column>

						<b-table-column  label="OPD No" centered v-slot="props">
                                  <span :class="props.row.status != -1 ? '' : 'has-text-danger' "> {{ props.row.opd_no }}</span> 
                        </b-table-column>


						<b-table-column  label="Pet Name" centered v-slot="props">
                                   <span :class="props.row.status != -1 ? '' : 'has-text-danger' ">  {{ props.row.pet_name }}</span> 
                        </b-table-column>


						<b-table-column  label="Owner" centered v-slot="props">
                                   <span :class="props.row.status != -1 ? '' : 'has-text-danger' "> {{ props.row.owner_name }}  {{ props.row.owner_surname }}</span> 
                        </b-table-column>

                        <b-table-column  label="Member ID" centered v-slot="props">
                             <!-- :disabled="props.row.status==-1"  -->
                                   <span :class="props.row.status != -1 ? '' : 'has-text-danger' "> {{ props.row.member_id }}  </span> 
                                   <!-- <b-tooltip position="is-top" multilined v-show="props.row.status != -1">
                                        <b-button type="is-primary is-light"
                                            
                                            @click="doPrepareInvoice(props.row)">
                                            {{ props.row.member_id }} 
                                        </b-button> 
                                        <template v-slot:content>
                                            ทำรายการใบแจ้งหนี้ <br/> <b>{{   props.row.member_name  }}</b>  
                                        </template>
                                    </b-tooltip> -->

                                   <!-- {{ props.row.member_id}} -->

                        </b-table-column>

                        <b-table-column  label="Member Name" centered v-slot="props">
                                    <span :class="props.row.status != -1 ? '' : 'has-text-danger' "> {{ props.row.member_name }}  </span> 
                        </b-table-column>


						<b-table-column  label="Species" centered v-slot="props">
                                   <span :class="props.row.status != -1 ? '' : 'has-text-danger' ">  {{ props.row.species }} </span> 
                        </b-table-column>

						<b-table-column  label="Breed" centered v-slot="props">
                                    <span :class="props.row.status != -1 ? '' : 'has-text-danger' "> {{ props.row.breed }} </span> 
                        </b-table-column>

						<b-table-column  label="Sum" centered v-slot="props">

                            <b-tooltip position="is-top" multilined   :type="props.row.status == -1 ? 'is-danger is-light'   : 'is-primary is-light'" >
                                        <b-button  :type="props.row.status == -1 ? 'is-danger is-light'   : 'is-primary is-light'"
                                             @click="viewDetailUsedPart(props.row.visit_no)"
                                             
                                             >
                                             {{ formatStringToCurrency( props.row.total_price ) }} 
                                        </b-button>
                                        <template v-slot:content>
                                            ดูรายละเอียด <br/> <b>{{ formatStringToCurrency( props.row.total_price )   }}</b>  
                                        </template>
                                    </b-tooltip>



                                         
                                    <!-- <span :class="props.row.status != -1 ? '' : 'has-text-danger' "> {{ formatStringToCurrency( props.row.total_price ) }} </span>  -->
                        </b-table-column>

						<b-table-column  label="Group" centered v-slot="props">
                                    <span :class="props.row.status != -1 ? '' : 'has-text-danger' "> {{   props.row.grp_fn }} </span> 
                        </b-table-column>

						<b-table-column  label="Lab No" centered v-slot="props">
                                  <span :class="props.row.status != -1 ? '' : 'has-text-danger' ">   {{   props.row.idlab }} </span> 
                        </b-table-column>

						<b-table-column  label="Order No" centered v-slot="props">
                                   <span :class="props.row.status != -1 ? '' : 'has-text-danger' ">  {{   props.row.idlabnonautomate }} </span> 
                        </b-table-column>

                        <b-table-column  label="Date/Time Record" centered v-slot="props">
                                 <span  :class="props.row.status != -1 ? 'is-size-6' : 'has-text-danger is-size-6' ">
                                    {{  getISO8601ToYearMonthDate( props.row.dt_rec ).date }}  
                                    {{  getISO8601ToYearMonthDate( props.row.dt_rec ).month }} 
                                    {{  getISO8601ToYearMonthDate( props.row.dt_rec ).year }} 
                                 </span> 
                                     


                                 <span  :class="props.row.status != -1 ? 'is-size-7 is-italic' : 'has-text-danger is-size-7 is-italic' "  >
                                     {{  getISO8601ToYearMonthDate( props.row.dt_rec ).hour }}:{{  getISO8601ToYearMonthDate( props.row.dt_rec ).minute }} 
                                 </span>    

                        </b-table-column>
                         
                        <b-table-column  label="User Record" centered v-slot="props">
                                    {{   props.row.user_rec_fn }} 
                        </b-table-column>

                        <!-- <b-table-column  label="Invoice" centered v-slot="props">
                                    {{   props.row.invoice }} 
                        </b-table-column> -->

                        <b-table-column  label="Status" centered v-slot="props">
                                    <!-- {{   props.row.ststus  }}  -->
                                        <b-icon
                                            icon="circle"
                                            :type="props.row.status != -1 ? 'is-success' : 'is-danger' "
                                            size="is-medium">
                                        </b-icon>
                        </b-table-column>

                        
                        <!-- <b-table-column  label="Print LN/LOR" centered v-slot="props">
                                    <b-tooltip position="is-top" multilined>
                                        <b-button type="is-primary is-light"
                                            @click="printStickerLab(props.row)">
                                            Print
                                        </b-button> 
                                        <template v-slot:content>
                                            Print <br/> <b>{{   props.row.idlab !=null ? props.row.idlab : props.row.idlabnonautomate }}</b> <br/>
                                            <i>{{ props.row.pet_name }}</i>  : <i>{{ props.row.owner_name }} {{ props.row.owner_surname }} </i>       

                                        </template>
                                    </b-tooltip>
                                     
                        </b-table-column> -->

                        <!-- <b-table-column  label="Print HN" centered v-slot="props">
                                    <b-button type="is-primary is-light"
                                      @click="printStickerHN(props.row)">
                                        Print
                                    </b-button>
                                   
                        </b-table-column> -->

 


						<template slot="empty">
                                <section class="section">
                                    <div class="content has-text-grey has-text-centered">
                                        <p>
                                            <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                            </b-icon>
                                        </p>
                                        <p>Nothing here.</p>
                                    </div>
                                </section>
                        </template>
		</b-table>						
	</section>



     <!-- <EditDocLabPCR
                :isComponentModalActive="isPCREditorShowing"
                :IDLABSelected="IDLABSelected"
                @close="closeEditDocLabPCR"
         /> -->

        <b-modal
                v-if="isNewCheckInPathoShowing"
                v-model="isNewCheckInPathoShowing"
                has-modal-card
                full-screen
                :can-cancel="true">
            <NewCheckInPatho v-if="isNewCheckInPathoShowing"
                     :isShowing="isNewCheckInPathoShowing"
                     @close="closeNewCheckInPatho"
                     @closeWithUpdate="closeNewCheckInPatho_WithUpdate"
            />
        </b-modal>



        <!-- <b-modal
                v-if="isPrepareMakeInvoiceShowing"
                v-model="isPrepareMakeInvoiceShowing"
                has-modal-card
                full-screen
                :can-cancel="true">
            <PrepareMakeInvoice v-if="isPrepareMakeInvoiceShowing"
                     :isShowing="isPrepareMakeInvoiceShowing"
                     :dataToChild_ArrJobID ="propsPrepareMakeInvoice_ArrJobID"
                     :dataToChild_MemberInfo="propsPrepareMakeInvoice_MemberInfo"
                     @close="closePrepareMakeInvoice"
                     @closeWithUpdate="closePrepareMakeInvoice_WithUpdate"
            />
        </b-modal> -->


        <b-modal
                    v-if="isDlgDetailUsedPartByJobIDShowing"
                    v-model="isDlgDetailUsedPartByJobIDShowing"
                    has-modal-card   
                    :can-cancel="true">
                <DlgDetailUsedPartByJobID v-if="isDlgDetailUsedPartByJobIDShowing"
                         :isShowing ="isDlgDetailUsedPartByJobIDShowing"
                         :dataProp = "dataPropDlgDetailUsedpart_jobID"
                         @close="closeDlgDetailUsedPartByJobID"
                         
                        
                />
        </b-modal>

    </div>
</template>



<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import formatStringToCurrency from '../../mixins/methods/formatStringToCurrency'
import getISO8601ToYearMonthDate from '../../mixins/methods/getISO8601ToYearMonthDate'
import axios from "axios";
import { getBaseURLforBackEnd , getConfigAxios , myTimeZone , CALL_FROM } from '@/utils.js'
import NewCheckInPatho from './NewCheckInPatho.vue'
// import PrepareMakeInvoice from './PrepareMakeInvoice_Unused.vue'
import moment from 'moment-timezone' 
import DlgDetailUsedPartByJobID from './DlgDetailUsedPartByJobID.vue'
import Papa from 'papaparse';

export default {
    name : "PathoListOfJobServices",
	mixins:[formatStringToCurrency,getISO8601ToYearMonthDate,],
    mounted(){
    
		if(this.datePathoJobStartModel == null){
            this.loadCurrentDate()
                 .then(()=>{
                     if(this.opdPathoJobList.length==0 &&  this.datePathoJobStopModel != null ){
                        this.loadJobListOfPathoServices()
                     }
                 })
       
        }

         
	},
    components:{
        NewCheckInPatho,
        // PrepareMakeInvoice,
        DlgDetailUsedPartByJobID,
    },
	computed:{
        ...mapState({
			opdPathoJobList : state => state.patho_opd_job_worklist.opdPathoJobList ,
            access_token : state => state.master_data.access_token ,

            datePathoJobStart : state => state.patho_opd_job_worklist.datePathoJobStart ,
            datePathoJobStop : state => state.patho_opd_job_worklist.datePathoJobStop ,
		}),


        datePathoJobStartModel:{
                get: function () {
                    return this.datePathoJobStart
                },
                set: function (newValue) {
                    this.setDatePathoJobStart(newValue)
                }
        },

        datePathoJobStopModel:{
                get: function () {
                    return this.datePathoJobStop
                },
                set: function (newValue) {
                    this.setDatePathoJobStop(newValue)
                }
        },


        
        opdPathoJobListForCSV(){
            return    this.opdPathoJobList.map(dat=>{
               return {
                "id" : dat.visit_no,
                "opd_no" : dat.opd_no,
                "opd_name" : dat.pet_name,
                "owner_name" : dat.owner_name,
                "owner_surname" :  dat.owner_surname,
                "species" :   dat.species,
                "breed" :   dat.breed,
                "total_price" :    dat.total_price,
                "member_name" :    dat.member_name,
                "type" :  dat.grp_fn
               } 
            })
                
            
        }  



	},
	methods:{
    ...mapMutations({
                setDatePathoJobStart : 'patho_opd_job_worklist/setDatePathoJobStart',
                setDatePathoJobStop : 'patho_opd_job_worklist/setDatePathoJobStop',
    }),
	...mapActions({
                fetchJobListOfPathoServices : 'patho_opd_job_worklist/fetchJobListOfPathoServices',
            }),


    saveToCSV(){
            const csv = Papa.unparse(this.opdPathoJobListForCSV);
            const blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), csv], { type: 'text/csv;charset=utf-8;' });
            if (window.navigator.msSaveOrOpenBlob) {
                // For IE and Edge
                window.navigator.msSaveBlob(blob, 'export.csv');
            } else {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'export.csv');
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url); // Release the object URL
            }
                // const csv = Papa.unparse(this.opdPathoJobListForCSV);
                // const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                // if (window.navigator.msSaveOrOpenBlob) {
                //     // For IE and Edge
                //     window.navigator.msSaveBlob(blob, 'export.csv');
                // } else {
                //     const url = window.URL.createObjectURL(blob);
                //     const link = document.createElement('a');
                //     link.href = url;
                //     link.setAttribute('download', 'export.csv');
                //     link.style.visibility = 'hidden';
                //     document.body.appendChild(link);
                //     link.click();
                //     document.body.removeChild(link);
                //     window.URL.revokeObjectURL(url); // Release the object URL
                // }
    },        

    disableJobID_Real(payload){
        const datTo ={
            "job_id" : payload.visit_no
        }
        this.isTableLoading = true
            axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
            axios.post(`${getBaseURLforBackEnd()}/api/disablepathoservicesbyjobid`,datTo,getConfigAxios())
                    .then(()=>{
                        // change status to -1
                        const tmp = this.opdPathoJobList.find(dat=>dat.visit_no == payload.visit_no)
                        if(tmp){
                            console.log("tmp", tmp.status,  tmp.visit_no)
                            tmp.status = -1
                        }
                        this.isTableLoading = false
                    })


    },
    disableJobID(payload){
        this.$buefy.dialog.confirm({
                    title: 'Deleting Visit or Job ID',
                    message: 'Are you sure you want to <b>delete</b> your Job ID? This action cannot be undone.',
                    confirmText: 'Delete',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => this.disableJobID_Real(payload)
                })
    },     
    
    
    closeDlgDetailUsedPartByJobID(){
      this.isDlgDetailUsedPartByJobIDShowing   = false
    },        
    viewDetailUsedPart(_job_id){
        this.dataPropDlgDetailUsedpart_jobID = _job_id
       this.isDlgDetailUsedPartByJobIDShowing   = true
    },
    closePrepareMakeInvoice(){
         this.isPrepareMakeInvoiceShowing = false
    },  
    closePrepareMakeInvoice_WithUpdate(){
         this.isPrepareMakeInvoiceShowing = false
    },  
    doPrepareInvoice(payload){
         //   console.log( JSON.stringify(payload))
         //   {"id":2,"visit_no":"L660000000000002","opd_no":"65000024","pet_name":"เฌอแตม (I)","owner_name":"กาญจนา","owner_surname":"ชิงชัยภูมิ","species":"สุนัข","breed":"CHIHUAHUA","dt_rec":"2023-03-16T12:15:07.579000","user_rec":1,"user_rec_fn":" ","total_price":4800.75,"member_real_id":1,"member_name":"โรงพยาบาลสัตว์ทิพย์พิมาน","member_id":"TP0001","status":0,"invoice":null,"receipt":null,"idlab":null,"detail_automate":null,"idlabnonautomate":"LOR660005628","detail_none_automate":[],"grp":1,"grp_fn":"NON-AUTAOMATE"}
         this.propsPrepareMakeInvoice_ArrJobID =    this.opdPathoJobList.filter(dat=>dat.member_id == payload.member_id && dat.status != -1  && dat.invoice == null)  // -1 == disabled
                                                                    //    .map(dat=>dat.visit_no)        
         this.propsPrepareMakeInvoice_MemberInfo = Object.assign({},{
                                              "member_id" : payload.member_id,
                                              "member_name" : payload.member_name,
                                              "member_real_id" : payload.member_real_id,
                                              })       
        //  console.log( " this.propsPrepareMakeInvoice_ArrJobID --> " ,this.propsPrepareMakeInvoice_ArrJobID.length)     
         if(this.propsPrepareMakeInvoice_ArrJobID.length>0){
            this.isPrepareMakeInvoiceShowing = true  
         }                                                                                      
                                                                                       
    },





    loadCurrentDate(){
             return new Promise((resolve) => {  
                                            axios.get(`${getBaseURLforBackEnd()}/api/curdatetime` ,getConfigAxios())
                                                .then( (response) => {
                                                            // this.datePathoJobStartModel =  new Date(   moment( new Date( Date.parse(response.data.current_datetime) )).subtract(30, 'days')  ) 
                                                            this.datePathoJobStopModel = new Date( Date.parse(response.data.current_datetime))    // new Date( Date.parse(response.data.current_datetime)) 
                                                            resolve(response)
                                                        }) 
    })

    },   
    checkDateValidate(){
                var from = moment( this.datePathoJobStartModel , myTimeZone );
                var to = moment( this.datePathoJobStopModel , myTimeZone );
                var diffDay =  to.diff(from, 'days')  
                // console.log(diffDay)
                 
                if(diffDay>=0 && diffDay<31){
                  return true
                }

                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: `pls select date data between 31 days `,
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'alert-circle',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })

              return false
    },
    
    clickCopyIntoClipboard(_id){
              this.$buefy.toast.open({
                    duration: 2000,
                    message: `Copy <b>${_id}</b> to clipboard`,
                    position: 'is-bottom',
                    type: 'is-primary is-light'
                })
    },        
    closeNewCheckInPatho_WithUpdate(){
        this.isNewCheckInPathoShowing = false
        this.loadJobListOfPathoServices()
    },        
    closeNewCheckInPatho(){
        this.isNewCheckInPathoShowing = false
    },        
    newCheckIn(){
        this.isNewCheckInPathoShowing = true
    },
    loadJobListOfPathoServices(){
        this.isTableLoading = true
        this.fetchJobListOfPathoServices()
        .then(()=>{
            this.isTableLoading = false
            this.currentPage = 1
        })
        .catch((err)=>{
            this.$buefy.dialog.alert({
                title: 'Error',
                message: `${err}`,
                type: 'is-danger',
                hasIcon: true,
                icon: 'alert-circle',
                ariaRole: 'alertdialog',
                ariaModal: true
            })
            this.isTableLoading = false
        })
	},
    printStickerHN(_data){
                   this.isTableLoading = true
                    const datTo = {"ref_no": _data.visit_no}
                    
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}/api/make_label_opd`,datTo,getConfigAxios())
                         .then((res)=>{
                            if(CALL_FROM == 1){  // 0 == labpatho.vet.ku.ac.th , 1 == local(172.16.2.116) , 2 == https://kuvdl.vet.ku.ac.th   
                                    window.open(`${res.data.url_local}`, '_blank', 'location=no,height=570,width=520,scrollbars=yes,status=yes')
                            }else{
                                    window.open(`${res.data.url}`, '_blank', 'location=no,height=570,width=520,scrollbars=yes,status=yes')
                            }
                             
                             this.isTableLoading = false
                    })
    },
    printStickerLab(_data){
                    // _data = {"id":1,"visit_no":"L660000000000001","opd_no":"58002007","pet_name":"เหมียว","owner_name":"วริฐา","owner_surname":"ศรุตธนภิญโญ","species":"แมว","breed":"DSH","dt_rec":"2023-04-09T11:40:41.892000","user_rec":1,"user_rec_fn":"ศักรินทร์ กล้าหาญ","total_price":3350,"invoice":null,"receipt":null,"idlab":null,"detail_automate":null,"idlabnonautomate":"LOR660005478","detail_none_automate":[],"grp":1,"grp_fn":"NON-AUTAOMATE"}
                    // console.log( JSON.stringify( _data.idlab))
                    this.isTableLoading = true
                    const datTo =  _data.idlab == null ?  {"lor": _data.idlabnonautomate}  :  {"idlab": _data.idlab}

                    // const endPoint = _data.idlab == null ? 'makelabel_ln_nonautomate' : 'makelabel_ln_cbc'
                    const endPoint = _data.idlab == null ? 'makelabel_ln_nonautomate_v2' : 'makelabel_ln_cbc_v2'
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}/api/${endPoint}`,datTo,getConfigAxios())
                         .then((res)=>{
                             if(CALL_FROM == 1){  // 0 == labpatho.vet.ku.ac.th , 1 == local(172.16.2.116) , 2 == https://kuvdl.vet.ku.ac.th   
                                    window.open(`${res.data.url_local}`, '_blank', 'location=no,height=570,width=520,scrollbars=yes,status=yes')
                              }else{
                                    window.open(`${res.data.url}`, '_blank', 'location=no,height=570,width=520,scrollbars=yes,status=yes')
                             }

                              
                             this.isTableLoading = false
                    })
    }


	},
	data(){
		return{
			isTableLoading : false,
			isEmpty : false,
            isNewCheckInPathoShowing : false,


            date_selected :  null,
            // checkedRows : [],

            isPrepareMakeInvoiceShowing : false,
            propsPrepareMakeInvoice_ArrJobID : [],
            propsPrepareMakeInvoice_MemberInfo : {}, //{
                                                    //     "member_id" : "",
                                                    //     "member_name" : "",
                                                    //     "member_real_id" : 
                                                    // }
            isDlgDetailUsedPartByJobIDShowing : false,
            dataPropDlgDetailUsedpart_jobID : "", // pass job_id


            perPage : 20 ,
            currentPage : 1, 

		}
	}
}
</script>